import React from "react";
import { classNames } from "../../helpers";
import { useSelector } from "react-redux";
import { loadingState } from "../../redux/reducers/loadingReducer";
import { ExclamationCircleIcon } from '@heroicons/react/16/solid'
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css"; // Default styles

/**
 * Countries tikitly currently operates in. The phone country selector offers these and
 * nothing else, so a number can never be entered for a market we cannot serve.
 *
 * Single source of truth — every phone field in the app renders through this component
 * (sign-in, sign-up, forgot password, profile, business profile, sellers, free tickets,
 * Stripe onboarding), so adding a market later is a one-line change here.
 *
 * The server enforces the same list on `users/registration` and on the profile-completion
 * path; this picker is the affordance, not the control.
 */
export const SUPPORTED_COUNTRIES = ["nl", "de", "be"];

export default function TwPhoneInputGroup(props) {
  const loadingReduxState = useSelector(loadingState);
  const { children, name = "", label = "", className = "", errors = {}, error = "", leftIcon = "", rightIcon = "" } = props
  let inputProps = { ...props }
  delete inputProps.leftIcon
  delete inputProps.rightIcon
  delete inputProps.errors
  let inputLableClass = "text-black/[0.6]"
  let inputClass = "text-gray-900 outline-gray-300 placeholder:text-gray-400 hover:outline-indigo-bz focus-within:outline-indigo-bz"
  if (name && errors[name] && errors[name] !== "") {
    props = {
      ...props,
      error: props.errors[name]
    };
  }
  if (props.error && props.error !== "") {
    inputLableClass = "text-red-600"
    inputClass = "text-red-900 outline-red-300 placeholder:text-red-300 focus-within:outline-red-600"
  }


  return (
    // <div className="sm:w-full sm:max-w-sm md:max-w-lg">
    <div className="w-full sm:w-full sm:max-w-sm md:max-w-lg">
      {label && (<label htmlFor={name} className={classNames("block text-sm/6 font-medium", inputLableClass)}>
        {label}
      </label>)}
      <div className="mt-2">
        <div className={classNames("flex items-center rounded-xl [bg-input-bz] px-3 py-3.5 md:px-4 md:py-4 outline outline-1 -outline-offset-1 outline-gray-300 hover-within:outline hover-within:outline-2 hover-within:-outline-offset-2 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 ", inputClass)}>
          <PhoneInput
            // Default selection. Before the spread, so a caller can still default a
            // specific field to another SUPPORTED country if that ever makes sense.
            country={"nl"}
            // inputClass="!w-full !py-2 !pl-12 !pr-4 !border !border-gray-300 !rounded-lg !shadow-sm focus:!border-blue-500 focus:!ring-blue-500"
            buttonClass="!border-0 !border-r !border-gray-300 !bg-transparent"
            dropdownClass="!bg-white !border !border-gray-300 !shadow-lg"
            {...inputProps}
            // AFTER the spread deliberately: the allowed list is a policy, not a default,
            // so no caller can widen it by passing its own onlyCountries.
            onlyCountries={SUPPORTED_COUNTRIES}
            aria-invalid={props.error ? "true" : ""}
            aria-describedby={props.error ? "email-error" : ""}
            inputClass={classNames("!bg-transparent block grow text-base text-gray-900 placeholder:text-gray-400 focus:outline focus:outline-0 sm:text-sm/6 !border-0 !w-full !shadow-none",
              props.error ? "pr-3" : "pr-0"
            )}
          />
          {rightIcon && (
            <div className="size-5">{rightIcon}</div>
          )}
          {props.error && (<ExclamationCircleIcon
            aria-hidden="true"
            className="pointer-events-none col-start-1 row-start-1 size-5 self-center justify-self-end text-red-500 sm:size-4"
          />)}
        </div>
      </div>
      {props.error && (<p id="email-error" className="mt-2 text-sm text-red-600">
        {props.error}
      </p>)}
    </div>
  );
}
